import React from 'react'
import IncidentPerAttribute from './IncidentPerAttribute'

const ValidIncidentsPerResponseStatus = () => {
    const monitorReport = false;

    return (
        <>
            <IncidentPerAttribute monitorReport={monitorReport} attributeType="RESPONSESTATUS" disaggregation="sex" />
        </>
    )
}

export default ValidIncidentsPerResponseStatus

